import get from 'lodash/get'
import set from 'lodash/set'

class StyleManager {
  rawCss = []

  rawCssBreakpoints = {}

  styles = {}

  styleOverrides = {}

  breakpoints = {}

  rawCssOverrides = []

  addCss(css, breakpoint = null) {
    if (breakpoint) {
      const styles = get(this.rawCssBreakpoints, breakpoint, [])
      styles.push(css)
      this.rawCssBreakpoints[breakpoint] = styles
    } else {
      this.rawCss.push(css)
    }

    return this
  }

  addOverrideCss(css) {
    this.rawCssOverrides.push(css)
  }

  addStyle(selector, property, value, breakpoint = null) {
    if (breakpoint) {
      set(this.breakpoints, [breakpoint, selector, property], value)
    } else {
      set(this.styles, [selector, property], value)
    }

    return this
  }

  render(wrapWithStyleTag = true) {
    if (
      !this.rawCss.length
      && !Object.keys(this.rawCssBreakpoints).length
      && !Object.keys(this.styles).length
      && !Object.keys(this.styleOverrides).length
      && !Object.keys(this.breakpoints).length
      && !this.rawCssOverrides.length
    ) {
      return ''
    }

    let output = ''
    if (wrapWithStyleTag) {
      output = '<style>\n'
    }

    this.rawCss.forEach((css) => {
      output += `${css}\n`
    })

    Object.keys(this.rawCssBreakpoints).forEach((breakpoint) => {
      const styles = this.rawCssBreakpoints[breakpoint]
      output += `@media ${breakpoint} {\n`
      styles.forEach((css) => {
        output += `${css}\n`
      })
      output += '}\n'
    })

    Object.keys(this.styles).forEach((selector) => {
      output += this.renderSelector(selector, this.styles[selector])
    })

    Object.keys(this.breakpoints).forEach((breakpoint) => {
      output += `@media ${breakpoint} {\n`
      Object.keys(this.breakpoints[breakpoint]).forEach((selector) => {
        output += this.renderSelector(selector, this.breakpoints[breakpoint][selector])
      })
      output += '}\n'
    })

    Object.keys(this.styleOverrides).forEach((selector) => {
      output += this.renderSelector(selector, this.styleOverrides[selector])
    })

    this.rawCssOverrides.forEach((css) => {
      output += `${css}\n`
    })

    if (wrapWithStyleTag) {
      output += '</style>'
    }

    return output
  }

  renderSelector(selector, properties) {
    let output = `${selector} {\n`
    Object.keys(properties).forEach((prop) => {
      const value = properties[prop]
      output += `${prop}: ${value};\n`
    })
    output += '}\n'

    return output
  }
}

export function createStyleManager() {
  return new StyleManager()
}
